import { createTheme } from "@mui/material";
import { familyMontserrat, familyNeueKabel } from "theme/fonts";
import palette from "theme/palette";

export const defaultTheme = createTheme(
  {
    palette,
  },
  {
    components: {
      MuiTypography: {
        variants: [
          {
            props: { variant: "h1" },
            style: { fontSize: 30, fontFamily: familyMontserrat },
          },
          {
            props: { variant: "h2" },
            style: { fontSize: 24, fontFamily: familyMontserrat },
          },
        ],
      },
      MuiButton: {
        variants: [
          {
            props: { variant: "contained" },
            style: { fontFamily: familyNeueKabel, textTransform: "none" },
          },
        ],
      },
    },
  },
);
